<template>
<v-flex offset-md1 md10 mb-5>
  <v-layout row wrap class="border-content mt-5 pa-4 mb-5">
    <v-flex sm12 mb-5 >
      <div class="company-header">
        Usuários
      </div>
      <table class="tb-users" cellspacing="0" cellspadding="0">
          <thead>
              <tr>
                  <th>Nome</th>
                  <th>Login</th>
                  <th>Telfone</th>
                  <th>E-mail</th>
                  <th>Departamento</th>
                  <th></th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="item in users" :key="item.id">
                <td>{{ item.nome }}</td>
                <td>{{ item.login }}</td>
                <td>{{ item.telefone }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.departamento }}</td>
                <td>
                    <v-btn icon flat color="grey lighten-1" slot="activator" @click.native.stop="itemEscolha(item.id)">
                    <v-icon>create</v-icon>
                    </v-btn>
                </td>
              </tr>
          </tbody>
      </table>
    </v-flex>
    <v-flex d-flex sm3>
        <v-layout row wrap>
          <v-flex sm6>
            <div class="v-subheader theme--light">itens por página</div>
          </v-flex>
          <v-flex sm6>
            <v-select
              single-line
              :value="itemsPerPage"
              bottom
              required
              v-model="ipp"
              v-bind:items="comboList"
              @change="refreshList"
            >
            </v-select>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex sm6>
        <v-layout row wrap justify-center>
          <p class="pt-3 pr-2 mb-0">{{pagingText}}</p>
        </v-layout>
      </v-flex>
      <v-flex d-flex sm3>
        <v-layout row wrap justify-end>
          <v-btn
              fab
              rounded
              outlined
              small
              @click.native="prev"
              v-show="currentPage > 1"
              >
                <v-icon light>arrow_back</v-icon>
          </v-btn>
          <v-btn
            fab
            rounded
            outlined
            small
            v-show="currentPage < totalPages"
            @click.native="next"
            >
              <v-icon light>arrow_forward</v-icon>
          </v-btn>
        </v-layout>
      </v-flex>
     
  </v-layout>
  <v-btn
      round
      large
      dark
      class="btn-green no-transform"
      @click.native.stop="itemEscolha(0)">
        <span class="pr-1">
          <v-icon dark>add_circle_outline</v-icon>
        </span>
        Novo Usuário
      </v-btn>
      <UsuarioDetalhes />
    </v-flex>
      

</template>
<script>
import UsuarioDetalhes from './usuarioDetalhe'

export default {
  name: 'Usuários',
  components: {
    UsuarioDetalhes
  },
  data () {
    return {
      comboList: [6, 12, 18, 24, 30],
      ipp: 12
    }
  },
  methods: {
    next () {
      this.$store.commit('nextPage')
      this.$store.dispatch('getUsers')
    },
    prev () {
      this.$store.commit('prevPage')
      this.$store.dispatch('getUsers')
    },
    refreshList () {
      this.$store.commit('changeItemsPerPage', this.ipp)
      this.$store.dispatch('getUsers')
    },
    itemEscolha (item) {
      this.$store.dispatch('selectUser', item)
    }
  },
  computed: {
    pagingText () {
      return `mostrando de ${((this.$store.getters.currentPage - 1) * this.$store.getters.itemsPerPage + 1)} a ${((this.$store.getters.currentPage * this.$store.getters.itemsPerPage) > this.$store.getters.totalItems ? this.$store.getters.totalItems : (this.$store.getters.currentPage * this.$store.getters.itemsPerPage))} de ${this.$store.getters.totalItems}`
    },
    users () {
      return this.$store.getters.users
    },
    currentPage () {
      return this.$store.getters.currentPage
    },
    itemsPerPage () {
      return this.$store.getters.itemsPerPage
    },
    totalPages () {
      return this.$store.getters.totalPages
    }
  },
  mounted () {
    this.$store.commit('resetPage')
    this.$store.dispatch('getUsers')
  }
}
</script>
<style>
.tb-users{width: 100%; border-collapse: collapse;}
.tb-users thead th{text-align:left;padding:5px;}
.tb-users tbody td{padding:5px;}
.tb-users thead tr{border-bottom: 1px solid #999}
.tb-users tbody tr{border-bottom: 1px solid #ddd}

</style>



// WEBPACK FOOTER //
// usuarios.vue?b380ff78